import { render, staticRenderFns } from "./SubListSection.vue?vue&type=template&id=235639b3&scoped=true&"
import script from "./SubListSection.vue?vue&type=script&lang=js&"
export * from "./SubListSection.vue?vue&type=script&lang=js&"
import style0 from "./SubListSection.vue?vue&type=style&index=0&id=235639b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235639b3",
  null
  
)

export default component.exports